import * as React from 'react';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import "./DatePicker.css";
import TubeSubmit from './TubeSubmit';

export default function DatePicker(props) {
    const { label, stateName, valueName, dispatchFunc, disabled, time, sx } = props;
    const value = useSelector((state) => state[stateName][valueName]);
    const dispatch = useDispatch();

    const handleChange = (value) => {
        console.log(value);
        dispatch(dispatchFunc({[valueName]: value}));
    }

    return (
        <>
            <div style={sx} className='date-picker-container'>
                {!time ? (
                    <DesktopDatePicker
                        className='date-picker'
                        label={label}
                        value={value}
                        onChange={handleChange}
                        disabled={disabled}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                        ampm={false}
                    />
                ) : (
                    <DateTimePicker
                        className='date-picker'
                        label={label}
                        value={value}
                        onChange={handleChange}
                        disabled={disabled}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                        ampm={false}
                    />
                )}
                <TubeSubmit
                    label={"Now"}
                    onClick={() => handleChange(new Date().toISOString())}
                    variant="outlined"
                    className={"date-picker-now-button"}
                />
            </div>
        </>
    );
}

DatePicker.propTypes = {
    label: PropTypes.string.isRequired,
    stateName: PropTypes.string.isRequired,
    valueName: PropTypes.string.isRequired,
    dispatchFunc: PropTypes.func.isRequired,
    sx: PropTypes.object,
    disabled: PropTypes.bool
};